import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AppSettingsService } from './app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {
baseUrl = AppSettingsService.appSettings.DocumentationAPIUrl;
private options = { headers: new HttpHeaders().set('Content-Type', 'application/octet-stream') };

constructor(private http: HttpClient) { }

getDownload(path: any) {
  return this.http.post(this.baseUrl + "/downloads/getFile", path, { observe: 'response', responseType: 'blob' as 'json'});
}

}
